import FormSection from './FormSection'
import { translations } from '../../data/translations'
import './FormSection.css'

const TimelineBudgetSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.timeline || translations.de.timeline

  return (
    <FormSection title={t.title} subtitle={t.subtitle}>
      <div className="form-group">
        <label htmlFor="launch_zeitraum" className="form-group__label">
          {t.launch_zeitraum} <span className="form-group__required">*</span>
        </label>
        <select
          id="launch_zeitraum"
          name="launch_zeitraum"
          className="form-group__input"
          value={formData.launch_zeitraum || ''}
          onChange={(e) => updateFormData('launch_zeitraum', e.target.value)}
          required
        >
          <option value="">{t.bitteWaehlen}</option>
          {t.launch_zeitraumOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="launch_datum" className="form-group__label">
          {t.launch_datum}
        </label>
        <input
          type="date"
          id="launch_datum"
          name="launch_datum"
          className="form-group__input"
          value={formData.launch_datum || ''}
          onChange={(e) => updateFormData('launch_datum', e.target.value)}
        />
      </div>

      <div className="form-group">
        <label htmlFor="deadline_grund" className="form-group__label">
          {t.deadline_grund}
        </label>
        <input
          type="text"
          id="deadline_grund"
          name="deadline_grund"
          className="form-group__input"
          placeholder={t.deadline_grundPlaceholder}
          value={formData.deadline_grund || ''}
          onChange={(e) => updateFormData('deadline_grund', e.target.value)}
        />
      </div>

      <div className="form-group">
        <label htmlFor="budget_rahmen" className="form-group__label">
          {t.budget_rahmen}
        </label>
        <select
          id="budget_rahmen"
          name="budget_rahmen"
          className="form-group__input"
          value={formData.budget_rahmen || ''}
          onChange={(e) => updateFormData('budget_rahmen', e.target.value)}
        >
          <option value="">{t.bitteWaehlen}</option>
          {t.budget_rahmenOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="budget_aufteilung" className="form-group__label">
          {t.budget_aufteilung}
        </label>
        <textarea
          id="budget_aufteilung"
          name="budget_aufteilung"
          className="form-group__input form-group__textarea"
          placeholder={t.budget_aufteilungPlaceholder}
          value={formData.budget_aufteilung || ''}
          onChange={(e) => updateFormData('budget_aufteilung', e.target.value)}
          style={{ minHeight: '80px' }}
        />
      </div>
    </FormSection>
  )
}

export default TimelineBudgetSection
